
import { TestResult } from "@/hooks/useTestResults";

export const calculateAverageScore = (testResults: TestResult[]): number => {
  if (!testResults || testResults.length === 0) return 0;
  const totalScore = testResults.reduce((sum, result) => sum + result.score, 0);
  return Math.round(totalScore / testResults.length);
};

export const calculateCategoryScores = (testResults: TestResult[]) => {
  return testResults.reduce((acc: Record<string, { total: number; count: number }>, result) => {
    const category = result.tests.category;
    if (!acc[category]) {
      acc[category] = { total: 0, count: 0 };
    }
    acc[category].total += result.score;
    acc[category].count += 1;
    return acc;
  }, {});
};
